export const API_VERSION = process.env.REACT_APP_IS_EMBEDDED ? 'games-api' : 'api';
